import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import { styled } from '@zenbusiness/zui/styles';

const WrapperStyle = ({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '4 / 10'
  }
});

const ButtonStyle = () => ({
  '&.Mui-disabled': {
    border: 'none'
  }
});

export const Wrapper = styled(Box)(WrapperStyle);
export const ButtonStyled = styled(Button)(ButtonStyle);
